/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S3_Li4Inputs */

const tr_kvkkbasvuru_s3_li4 = /** @type {(inputs: Kvkkbasvuru_S3_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varsa bildirime esas elektronik posta adresi, telefon ve faks numarası`)
};

const en_kvkkbasvuru_s3_li4 = /** @type {(inputs: Kvkkbasvuru_S3_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If available, the email address, telephone and fax number used for notifications`)
};

const de_kvkkbasvuru_s3_li4 = /** @type {(inputs: Kvkkbasvuru_S3_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sofern vorhanden, die für Mitteilungen maßgebliche E-Mail-Adresse, Telefon- und Faxnummer`)
};

const ru_kvkkbasvuru_s3_li4 = /** @type {(inputs: Kvkkbasvuru_S3_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При наличии адрес электронной почты, номер телефона и факса для уведомлений`)
};

/**
* | output |
* | --- |
* | "If available, the email address, telephone and fax number used for notifications" |
*
* @param {Kvkkbasvuru_S3_Li4Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s3_li4 = /** @type {((inputs?: Kvkkbasvuru_S3_Li4Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S3_Li4Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s3_li4(inputs)
	if (locale === "de") return de_kvkkbasvuru_s3_li4(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s3_li4(inputs)
	return tr_kvkkbasvuru_s3_li4(inputs)
});